import React, {useEffect, useState} from 'react';
import formatNumber from "../../utils/formatNumber";
import feather from "feather-icons";
import {teamReport} from "../../api/app";
const $ = window.$;

const Revenue = (props) => {
    const [report, setReport] = useState([]);

    useEffect(() => {
        feather.replace();
    }, []);

    useEffect(() => {
        teamReport(props.id).then((response) => {
            setReport(response.payload.data.results);
            $("#total-assignment").text(formatNumber(response.payload.total_assignment));
            $("#total-users").text(formatNumber(response.payload.total_user));
        });
    }, []);

    return (
        <div className="col-12 col-lg-12">
            <div className="card mg-b-10">
                <div className="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                    <div>
                        <h6 className="mg-b-5">Top User Performer</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">Top App user performer of the completed task.</p>
                    </div>
                </div>

                <div className="card-body pd-y-30">
                    <div className="d-sm-flex">
                        <div className="media align-items-center">
                            <div className="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6">
                                <i data-feather="bar-chart-2"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Total Assignment</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                            </div>
                        </div>
                        <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div className="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                <i data-feather="bar-chart-2"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Total Users</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-users">0</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-dashboard mg-b-0">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th className="text-right">Pending Task</th>
                            <th className="text-right">Complete Task</th>
                            <th className="text-right">Total Submission</th>
                        </tr>
                        </thead>
                        <tbody>
                        {report.map((item) => {
                            return (
                                <tr>
                                    <td className="tx-color-03 tx-normal text-capitalize">{item.name}</td>
                                    <td className="tx-medium text-right">{formatNumber(item.pending_count, "digit")}</td>
                                    <td className="text-right tx-medium tx-primary">{formatNumber(item.completed_count, "digit")}</td>
                                    <td className="text-right tx-medium tx-pink">{formatNumber(item.submission_count, "digit")}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Revenue;
